import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchCulinaryStudioArticleCategoriesThunk, fetchLeadFormThunk } from 'shared/lib';
import { CulinaryStudioPageState } from './state';
import { CulinaryStudioPageActions, GetCulinaryStudioServiceActionResponseMapper } from './actions';
import BaseError from '../../../utils/base-error';
import {
    createCulinaryStudioArticleCardsFromGetCulinaryStudioArticleCardsByCategoryUidApiResponse,
    createCulinaryStudioArticleCategoriesFromGetCulinaryStudioArticleCategoriesApiResponse,
} from '../utils';

const initialState: CulinaryStudioPageState = {
    loaded: false,
    errors: [],
    culinaryStudioArticleCategories: [],
    culinaryStudioArticleCards: [],

    title: 'Кулинарная студия',
    image: {
        url: '', // TODO
    },
};

export const culinaryStudioPageSlice = createSlice({
    name: 'culinaryStudioPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        /**
         * Обработчик получения списка типов баров (коллекция culinaryStudioArticleCategory)
         */
        builder.addCase(
            fetchCulinaryStudioArticleCategoriesThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createCulinaryStudioArticleCategoriesFromGetCulinaryStudioArticleCategoriesApiResponse(
                            response.data,
                        );

                        state.culinaryStudioArticleCategories = result;
                        state.loaded = true;
                    } catch (e) {
                        // return new BaseError(400, String(e));
                        // TODO
                    }
                }
            },
        );
        /**
         * Обработчик получения списка карточек
         * выездных баров по типу (коллекция CulinaryStudioArticle)
         */
        builder.addCase(
            CulinaryStudioPageActions.getCulinaryStudioArticleCardsByCategoryUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createCulinaryStudioArticleCardsFromGetCulinaryStudioArticleCardsByCategoryUidApiResponse(
                            response.data,
                        );
                        state.culinaryStudioArticleCards = result;
                        state.loaded = true;
                    } catch (e) {
                        // return new BaseError(400, String(e));
                        // TODO
                    }
                }
            },
        );
        builder.addCase(
            CulinaryStudioPageActions.getCulinaryStudioService.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        state.title = GetCulinaryStudioServiceActionResponseMapper.getTitle(
                            response,
                        );
                        state.description = GetCulinaryStudioServiceActionResponseMapper
                            .getDescription(
                                response,
                            );
                        state.image = GetCulinaryStudioServiceActionResponseMapper.getImage(
                            response,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
